import { faEllipsisVertical, faRotateLeft, faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"
import { Button, Form, InputGroup } from "react-bootstrap"
import { useDrag, useDrop } from "react-dnd"
import ReferenceModalRemove from "./ReferenceModalRemove"
import ReferenceModalArchiveCancel from "./ReferenceModalArchiveCancel"

function ReferenceBlockItem({ model, index, loading, changeTextHandler, remove, archiveCancel, moveFile, archive }) {

    const ref = useRef(null)
    const [{ handlerId }, drop] = useDrop({
        accept: "param_reference",
        /*drop: () => ({
            model, //Передаем в useDrag
        }),*/
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item, monitor) {
            if (!ref.current) {
                return
            }

            const dragIndex = item.index
            const hoverIndex = index

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }

            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()
            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()

            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }

            // Time to actually perform the action
            //moveBoard({ dragIndex: dragIndex, hoverIndex: hoverIndex, id_board_old: model.ID_Board, id_board_new: model_.model.ID_Board })
            moveFile({ dragIndex: dragIndex, hoverIndex: hoverIndex })
            //console.log('2', model.ID_Board)
            //console.log(monitor.getDropResult())
            //console.log(model)
            // console.log(model_.model)

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    })
    const [{ isDragging }, drag] = useDrag({
        type: "param_reference",
        item: () => {
            return { model, index }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            //item - Изменяемая модель
            if (monitor.getDropResult() !== null) {

                //СОХРАНЕНИЕ ИЗМЕНЕНИЙ
                // moveFileSaveHandler()
            }
        }
    })
    const opacity = isDragging ? 0 : 1

    /* useEffect(() => {
         if (loading === false & archive === false) {
             drag(drop(ref))
         }
         else {
             drag(null)
         }
     }, [loading]);*/

    const style = {
        marginTop: '.5rem',
    }
    drag(drop(ref))


    const [modalRemove, setModalRemove] = useState(false);
    const [modalArchiveCancel, setModalArchiveCancel] = useState(false);

    return (
        <>
            {modalRemove === true && model.id !== null && (
                <ReferenceModalRemove show={modalRemove} onHide={() => setModalRemove(false)} name={model.name} idItem={model.id} /*update={removeReferencerDb}*/ />
            )}
            {modalArchiveCancel === true && model.id !== null && (
                <ReferenceModalArchiveCancel show={modalArchiveCancel} onHide={() => setModalArchiveCancel(false)} name={model.name} idItem={model.id} /*update={loadReferenceList}*/ />
            )}
            <div ref={ref} data-handler-id={handlerId} style={{ ...style, opacity }}>
                <InputGroup key={index} className="mt-10">
                    <Button variant="light" disabled={loading}>
                        <FontAwesomeIcon icon={faEllipsisVertical} />
                    </Button>
                    <Form.Control
                        placeholder="Значение параметра..."
                        defaultValue={model.name}
                        onChange={(e) => changeTextHandler(e.target.value, model.num)}
                        disabled={archive === true ? true : loading}
                    />
                    {archive === true ? (
                        <Button variant="outline-secondary" onClick={() => { archiveCancel(model.num) }} disabled={loading}>
                            <FontAwesomeIcon icon={faRotateLeft} />
                        </Button>
                    ) : (
                        <Button variant="outline-danger" onClick={() => remove(model.num)} disabled={loading}>
                            <FontAwesomeIcon icon={faTrash} />
                        </Button>
                    )}
                </InputGroup>
            </div>
        </>
    );
}
export default ReferenceBlockItem;
